import { useMemo } from 'react';

import { useFormContext } from 'react-hook-form';

export const useCheckFlag = <T extends string>(path: string, flag: T) => {
  const { getValues } = useFormContext();
  const flags = getValues(path);

  return useMemo(() => flags?.includes(flag), [flags, flag]);
};
